import { SET_PLAYLIST_DETAIL } from '../../actions/musica/playlistdetails';

const initialState = {
  "playlistDetail": {
    "id": "",
    "title": "",
    "author": "",
    "cover": "",
    "numTracks": "",
    "duration": "",
    "tracks": [],
    "followers": 0,
    "isFreePlaylist": false,
    "isUserPlaylist": false,
    "isOwnPlaylist": false,
    "isLoading": false,
    "isIdentifiedSongsPlaylist": false
  }
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PLAYLIST_DETAIL:
      return { ...action.playlistDetail, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/musica/playlistdetails.js